import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-20 px-6 bg-white" data-id="element-231">
      <div className="max-w-5xl mx-auto" data-id="element-232">
        <FadeIn data-id="element-233">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-234">
            Por qué lo que has intentado no ha funcionado
          </h2>
          <div className="grid md:grid-cols-3 gap-8 mb-20" data-id="element-235">
            <div className="bg-red-50 rounded-2xl p-8 border border-red-100" data-id="element-236">
              <XCircle className="text-red-500 w-12 h-12 mb-6 mx-auto" data-id="element-237" />
              <h3 className="text-xl font-bold text-center mb-4" data-id="element-238">
                Beber agua sin orden
              </h3>
              <p className="text-gray-700 text-center" data-id="element-239">
                Inundar tus riñones sin los electrolitos correctos solo los
                obliga a trabajar el doble.
              </p>
            </div>
            <div className="bg-red-50 rounded-2xl p-8 border border-red-100" data-id="element-240">
              <XCircle className="text-red-500 w-12 h-12 mb-6 mx-auto" data-id="element-241" />
              <h3 className="text-xl font-bold text-center mb-4" data-id="element-242">
                Dietas genéricas
              </h3>
              <p className="text-gray-700 text-center" data-id="element-243">
                Lo que es "sano" para otros (como las espinacas o el plátano)
                puede ser veneno para tus riñones bajo estrés.
              </p>
            </div>
            <div className="bg-red-50 rounded-2xl p-8 border border-red-100" data-id="element-244">
              <XCircle className="text-red-500 w-12 h-12 mb-6 mx-auto" data-id="element-245" />
              <h3 className="text-xl font-bold text-center mb-4" data-id="element-246">
                Esperar pasivamente
              </h3>
              <p className="text-gray-700 text-center" data-id="element-247">
                El tejido renal que se cicatriza no se recupera. Cada día de
                inflamación cuenta.
              </p>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-248">
          <div className="bg-forest text-white rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-249">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full -translate-y-1/2 translate-x-1/3 blur-3xl" data-id="element-250"></div>

            <h2 className="text-3xl md:text-4xl font-bold text-center mb-6 relative z-10" data-id="element-251">
              El Lavado de Limpieza Profunda
            </h2>
            <p className="text-xl text-center text-cream/90 mb-12 relative z-10 max-w-3xl mx-auto" data-id="element-252">
              Este protocolo utiliza un sistema de 3 capas diseñado para dar
              resultados en 14 días:
            </p>

            <div className="space-y-6 relative z-10" data-id="element-253">
              <div className="flex gap-6 items-center bg-white/10 p-6 rounded-2xl backdrop-blur-sm" data-id="element-254">
                <div className="bg-amber p-4 rounded-full shrink-0" data-id="element-255">
                  <CheckCircle2 className="text-white w-8 h-8" data-id="element-256" />
                </div>
                <div data-id="element-257">
                  <h3 className="text-2xl font-bold mb-2 text-amber" data-id="element-258">
                    Nutrición de Rescate
                  </h3>
                  <p className="text-lg text-cream/90" data-id="element-259">
                    Alimentos que actúan como imanes de toxinas nitrogenadas.
                  </p>
                </div>
              </div>

              <div className="flex gap-6 items-center bg-white/10 p-6 rounded-2xl backdrop-blur-sm" data-id="element-260">
                <div className="bg-amber p-4 rounded-full shrink-0" data-id="element-261">
                  <CheckCircle2 className="text-white w-8 h-8" data-id="element-262" />
                </div>
                <div data-id="element-263">
                  <h3 className="text-2xl font-bold mb-2 text-amber" data-id="element-264">
                    Hidratación Osmótica
                  </h3>
                  <p className="text-lg text-cream/90" data-id="element-265">
                    Una fórmula de agua alcalinizada que neutraliza la acidez de
                    tu sangre.
                  </p>
                </div>
              </div>

              <div className="flex gap-6 items-center bg-white/10 p-6 rounded-2xl backdrop-blur-sm" data-id="element-266">
                <div className="bg-amber p-4 rounded-full shrink-0" data-id="element-267">
                  <CheckCircle2 className="text-white w-8 h-8" data-id="element-268" />
                </div>
                <div data-id="element-269">
                  <h3 className="text-2xl font-bold mb-2 text-amber" data-id="element-270">
                    Suplementación de Escudo
                  </h3>
                  <p className="text-lg text-cream/90" data-id="element-271">
                    Compuestos naturales que desinflaman el glomérulo de
                    inmediato.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}